/**
 * Knowledge Base Service
 * Handles knowledge base-related API calls
 */

import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import { KnowledgeBaseAdapter } from '@/adapters';
import type {
  ApiResponse,
  KnowledgeBase,
  KnowledgeBasesListResponseDto,
} from '@/types';

export const knowledgeBaseService = {
  /**
   * Get all knowledge bases
   */
  async getKnowledgeBases(): Promise<KnowledgeBase[]> {
    const response = await api.get<ApiResponse<KnowledgeBasesListResponseDto>>(
      API_ENDPOINTS.KNOWLEDGE_BASES.BASE
    );
    return KnowledgeBaseAdapter.fromApiList(response.data.data.knowledgeBases);
  },

  /**
   * Get multiple knowledge bases by IDs (batch fetch)
   */
  async getKnowledgeBasesByIds(ids: string[]): Promise<KnowledgeBase[]> {
    if (!ids || ids.length === 0) {
      return [];
    }

    // Use batch endpoint for efficient server-side filtering
    const response = await api.post<ApiResponse<KnowledgeBasesListResponseDto>>(
      API_ENDPOINTS.KNOWLEDGE_BASES.BATCH,
      { ids }
    );
    return KnowledgeBaseAdapter.fromApiList(response.data.data.knowledgeBases);
  },
};

